<template>
  <Teleport to="#modal">
    <div
      class="modal d-block centered base-modal-overlay"
      id="authModal"
      tabindex="-1"
      role="dialog"
      :class="{ 'inga-modal-overlay-dark': store.state.isDarkMode }"
    >
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 420px">
        <div
          class="modal-content border-0"
          :class="{ 'inga-modal-panel-dark': store.state.isDarkMode }"
        >
          <div class="modal-header mx-2 d-flex justify-content-between align-items-center border-bottom-0">
            <h4
              class="modal-title-stack mb-0"
              :class="{ 'text-slate-100': store.state.isDarkMode }"
            >
              <span class="modal-title-main">{{ title.main }}</span>
              <span class="modal-title-sub">{{ title.sub }}</span>
            </h4>
            <span
              class="inga-close-btn"
              :class="{ 'inga-close-btn-dark': store.state.isDarkMode }"
              role="button"
              tabindex="0"
              aria-label="Zavřít"
              @click="close"
              @keydown.enter.prevent="close"
              @keydown.space.prevent="close"
            >&times;</span>
          </div>
          <div class="modal-body auth-body">
            <login-form v-if="store.state.showForm == 'login'" />
            <register-form v-else-if="store.state.showForm == 'register'" />
            <forgot-password-form v-else-if="store.state.showForm == 'forgot-password'" />
            <change-password-form v-else-if="store.state.showForm == 'change-password'" />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import LoginForm from "./LoginForm.vue";
import RegisterForm from "./RegisterForm.vue";
import ForgotPasswordForm from "./ForgotPasswordForm.vue";
import ChangePasswordForm from "./ChangePasswordForm.vue";

const store = useStore();

const titles = {
  login: { main: "Přihlášení", sub: "k účtu" },
  register: { main: "Registrace", sub: "nový účet" },
  "forgot-password": { main: "Obnovení", sub: "hesla" },
  "change-password": { main: "Změna", sub: "hesla" }
};

const title = computed(() => titles[store.state.showForm] || titles.login);

const close = () => {
  store.dispatch("loadingModule/setButtonLoading", false);
  store.commit("SET_AUTH_MODAL", false);
};

const onKey = (event) => {
  if (event.key === "Escape") close();
};

onMounted(() => {
  store.dispatch("loadingModule/setButtonLoading", false);
  window.addEventListener("keydown", onKey);
});

onUnmounted(() => {
  window.removeEventListener("keydown", onKey);
});
</script>

<style scoped>
.base-modal-overlay {
  z-index: 2300 !important;
}

.modal-title-stack {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.modal-title-main {
  font-weight: 800;
  font-size: 1.15rem;
}

.modal-title-sub {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: lowercase;
  opacity: 0.92;
}

.text-slate-100 {
  color: #FFFFFF !important;
}

.auth-body {
  padding: 0.15rem 1.35rem 1.2rem !important;
}

.inga-close-btn {
  -webkit-appearance: none !important;
  appearance: none !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #94a3b8 !important;
  font-size: 1.75rem !important;
  font-weight: 800 !important;
  line-height: 1 !important;
  padding: 0 4px !important;
  cursor: pointer;
}

:deep(.auth-form .auth-lead) {
  font-size: 0.8rem;
  line-height: 1.35;
  max-width: 16rem;
}

:deep(.auth-form .form-control) {
  border-radius: 0.75rem;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  min-height: 3rem;
  box-shadow: none;
}

:deep(.auth-form .form-control:focus) {
  background: #FFFFFF;
  border-color: #FF8A4C;
  color: #0F172A;
  box-shadow: 0 0 0 3px rgba(255, 138, 76, 0.22);
}

.inga-modal-panel-dark :deep(.auth-form .form-control) {
  background: #1E293B;
  border-color: #64748B;
  color: #E2E8F0;
}

.inga-modal-panel-dark :deep(.auth-form .form-control:focus) {
  background: #475569;
  border-color: #FF8A4C;
  color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(255, 138, 76, 0.28);
}

.inga-modal-panel-dark :deep(.auth-form .form-control::placeholder) {
  color: #94A3B8;
}

.inga-modal-panel-dark :deep(.auth-lead) {
  color: #CBD5E1 !important;
}
</style>
